import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

export const SETTINGS_REDUCER_KEY = "settings";

const initialState = {
  currentActions: [], // used to display current user actions [local visualization only]
  actionsChanges: [], // {action: actionKey, role: roleKey, selected:boolean} [changes to send to BE]
  language: localStorage.getItem("tm-language") || "en-US",
};

const settingsSlice = createSlice({
  name: SETTINGS_REDUCER_KEY,
  initialState,
  reducers: {
    setCurrentActions: (state, { payload }) => {
      state.currentActions = payload;
    },
    updateCurrentActions: (state, { payload }) => {
      const newActions = updateCurrentActionsHelper(payload, [
        ...state.currentActions,
      ]);

      state.currentActions = newActions;
    },
    addAction: (state, { payload }) => {
      const newChanges = addActionHelper(payload, [...state.actionsChanges]);
      state.actionsChanges = newChanges;
    },
    clearActionsChanges: (state) => {
      state.actionsChanges = [];
    },
    changeLanguage: (state, { payload }) => {
      state.language = payload;
    },
  },
});

export default settingsSlice.reducer;

export const {
  addAction,
  setCurrentActions,
  updateCurrentActions,
  clearActionsChanges,
  changeLanguage,
} = settingsSlice.actions;

export const useSelectActionsChanges = () => {
  return useSelector((state) => state[SETTINGS_REDUCER_KEY].actionsChanges);
};

export const useSelectCurrentActions = () => {
  return useSelector((state) => state[SETTINGS_REDUCER_KEY].currentActions);
};

export const useSelectLanguage = () => {
  return useSelector((state) => state[SETTINGS_REDUCER_KEY].language);
};

function addActionHelper(action, actionChanges) {
  const changes = actionChanges.find(
    (change) => change.action === action.action && change.role === action.role,
  );
  if (changes) {
    const removeIndex = actionChanges.findIndex(
      (change) =>
        change.action === action.action && change.role === action.role,
    );
    if (removeIndex > -1) {
      // we remove it from the list if its clicked again so its back to initial state
      // and we don't need to send request for this action
      actionChanges.splice(removeIndex, 1);
    }
  } else {
    actionChanges.push(action);
  }

  return actionChanges;
}

function updateCurrentActionsHelper(action, currentActions) {
  const updatedActions = currentActions.reduce((acc, curr, i) => {
    if (curr.action === action.action) {
      const updatedRoles = curr.roles.map((role) =>
        role.role === action.role
          ? { ...role, selected: action.selected }
          : role,
      );
      acc.push({ ...curr, roles: updatedRoles });
    } else {
      acc.push(curr);
    }
    return acc;
  }, []);

  return updatedActions;
}
